module.exports = __webpack_public_path__ + "60040d722a9f5d7a132af87fd53b11a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/images/csgo/train.png
// module id = 1052
// module chunks = 0